import { render, staticRenderFns } from "./RegraSituacao.vue?vue&type=template&id=467ddc4e&scoped=true"
import script from "./RegraSituacao.vue?vue&type=script&lang=js"
export * from "./RegraSituacao.vue?vue&type=script&lang=js"
import style0 from "./RegraSituacao.vue?vue&type=style&index=0&id=467ddc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467ddc4e",
  null
  
)

export default component.exports